// extracted by mini-css-extract-plugin
export default {"input":"styles_input__OKMRG","heading":"styles_heading__QJFkm","wrapper":"styles_wrapper__CELeu","error":"styles_error__DU6Qx"};